export default __webpack_public_path__ + "static/media/Arm-straps of Crimson Slaughter.04d614fd.jpg";